import { formatNumberBasedOnUser } from "utils/namesManipulation";
import { getCSSVar } from "utils/styling";

import type { EnergyAnalysisMixCell } from "../model/types";

import { toEnergyAnalysisLabel } from "./labels";

export const buildHeatmapOption = (
  cells: EnergyAnalysisMixCell[],
  useTypes: string[],
  utilities: string[],
  rangeMax?: number
) => {
  const values = useTypes.flatMap((useType, yIndex) =>
    utilities.map((utility, xIndex) => {
      const match = cells.find((cell) => cell.useType === useType && cell.utility === utility);
      return [xIndex, yIndex, match?.value ?? 0];
    })
  );
  const maxValue = values.reduce((max, point) => {
    const value = point[2] ?? 0;
    return value > max ? value : max;
  }, 0);
  return {
    dataZoom: [],
    grid: {
      bottom: 42,
      containLabel: true,
      left: 8,
      right: 72,
      top: 12,
    },
    series: [
      {
        data: values,
        label: {
          formatter: (params: { value: number[] }) =>
            formatNumberBasedOnUser(params.value[2] ?? 0, 2),
          show: true,
        },
        type: "heatmap",
      },
    ],
    tooltip: {
      formatter: (params: { value: number[] }) => {
        const utility = utilities[params.value[0] ?? 0];
        const useType = useTypes[params.value[1] ?? 0];
        return `${toEnergyAnalysisLabel(useType ?? "")} · ${toEnergyAnalysisLabel(utility ?? "")}: ${formatNumberBasedOnUser(params.value[2] ?? 0, 2)}`;
      },
    },
    visualMap: {
      calculable: true,
      inRange: {
        color: [getCSSVar("--core-color-star-100"), getCSSVar("--core-color-mystic-red-600")],
      },
      max: rangeMax ?? maxValue,
      min: 0,
      orient: "vertical",
      right: 0,
      top: "middle",
    },
    xAxis: [
      {
        boundaryGap: true,
        data: utilities.map(toEnergyAnalysisLabel),
        splitArea: { show: true },
        type: "category",
      },
    ],
    yAxis: [
      {
        boundaryGap: true,
        data: useTypes.map(toEnergyAnalysisLabel),
        splitArea: { show: true },
        type: "category",
      },
    ],
  };
};
